import { Record } from 'immutable';
import { verifyUnsubTokenActions, redeemUnsubTokenActions } from './opt-out.actions';
import * as api from '../../api';

/**
 * Data pertaining to the currently requested opt-out operation
 */
export const OptOutState = Record({
  /**
   * Holds the result of the call to redeem an unsubscribe token.
   */
  redemption: api.ApiCallState({}),
  /**
   * Holds the result of the call to validate an unsubscribe token;
   * this should contain an error if the token has already been
   * redeemed, or is expired.
   */
  valid: api.ApiCallState({}),
});

export const optOutReducer = (initialState = new OptOutState(), action) => {

  var state = initialState.set('redemption',
    api.apiCallReducer(initialState.get('redemption'), action, redeemUnsubTokenActions));

  state = state.set('valid',
    api.apiCallReducer(state.get('valid'), action, verifyUnsubTokenActions));

  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/acct/opt-out/opt-out.reducer.js